console.log('CASEN-2024');
export const environment = {
  production: true,
  // apiUrl: 'http://127.0.0.1:8001'
  apiUrl: "https://be-casen2024-962569569378.us-east1.run.app"
};